export default __webpack_public_path__ + "static/media/027-intersection.6bc4364d.png";